import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';
import { TranscriptImportDialogState } from '../transcript-import-dialog.state';

import { ListMeetings } from './list-meetings.action';

export function listMeetingsReducer(
    state: TranscriptImportDialogState,
    action: PayloadAction<ActionType, ListMeetings>,
): TranscriptImportDialogState {
    if (action.payload.stop === true) {
        return {
            ...state,
            pending: {
                ...state.pending,
                meetings: null,
            },
            currentRequestToken: null,
        };
    } else {
        return {
            ...state,
            pending: {
                ...state.pending,
                meetings: true,
            },
            currentRequestSelectedUserId: state.selectedUserId,
            currentRequestToken: action.payload.token,
            meetings: null,
        };
    }
}
